export default __webpack_public_path__ + "static/media/room3.0fc91a93.jpg";